import resetButtonStateAfterActivity from './resetButtonStateAfterActivity';
import setButtonStateDuringActivity from './setButtonStateDuringActivity';
import getElementTransitionDuration from './getElementTransitionDuration';
/**
 * Initialize event listener to set submit button state while a form is being submitted in a traditional way (no AJAX).
 * @param {HTMLElement} buttonElement - The button DOM element,
 */

function initRegularFormSubmissionActivity (buttonElement: HTMLButtonElement) {

	if (!buttonElement) {

		return;

	}

	const form = buttonElement.form!;
	const buttonTransitionDuration = getElementTransitionDuration(buttonElement);
	const clickListener = (e: MouseEvent) => {

		// cancel submit, we'll trigger it manually
		e.preventDefault();

		// ignoring TS error "Property 'valid' does not exist on type 'JQuery<any>'"
		// @ts-ignore
		const isFormValid = $(form).valid();
		if (isFormValid) {

			// set submit button state before form is submitted
			setButtonStateDuringActivity(buttonElement);

			// Button may have CSS transition duration (currently only mobile has it)
			if (buttonTransitionDuration === 0) {

				form.submit();
				return;

			}

			// Safari needs a delay as it pauses CSS transition on form submission
			setTimeout(() => {

				form.submit();

			}, buttonTransitionDuration);

		} else {

			// Find the first input or select element with the "error" class
			const firstErrorInputOrSelect = form.querySelector('input.error, div.error>input, select.error');

			if (firstErrorInputOrSelect) {

				// Focus on the first input or select element with the error
				(firstErrorInputOrSelect as HTMLInputElement).focus();

			}

		}

	};

	buttonElement.removeEventListener('click', clickListener);
	buttonElement.addEventListener('click', clickListener);

	const unloadListener = () => {

		resetButtonStateAfterActivity(buttonElement);
		form.reset();

	};

	window.removeEventListener('pagehide', unloadListener);
	window.addEventListener('pagehide', unloadListener);

}

export default initRegularFormSubmissionActivity;
